import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { revertAll } from '../actions';

export interface IUserState {
    cognitoUser: any;
    authenticationDetails: any;
    number: any;
    accessToken: string;
    idToken: string;
    refreshToken: string;
    userDetails: any;
    isLoggedIn: boolean;
    selectedLang: string;
    userId: string | null;
    userName: string;
    userImageLink: string;
}

const initialState: IUserState = {
    cognitoUser: null,
    authenticationDetails: null,
    number: null,
    accessToken: '',
    idToken: '',
    refreshToken: '',
    userDetails: null,
    isLoggedIn: false,
    selectedLang: 'en',
    userId: null,
    userName: '',
    userImageLink: '',
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        loginSuccess: (state, action) => {
            return {
                ...state,
                idToken: action.payload.idToken,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
            };
        },
        saveCognitoUserInfo: (state, action) => {
            return {
                ...state,
                cognitoUser: action.payload.cognitoUser,
            };
        },
        saveUserDetails: (state, action) => {
            return {
                ...state,
                userDetails: action.payload,
            };
        },
        updateLoginStatus: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isLoggedIn: action.payload,
            };
        },
        updateUserLanguage: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                selectedLang: action.payload,
            };
        },
        setUserId: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                userId: action.payload,
            };
        },
        setUserName: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                userName: action.payload,
            };
        },
        setUserImageLink: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                userImageLink: action.payload,
            };
        },
    },
    extraReducers: builder => builder.addCase(revertAll, () => initialState),
});

export const {
    loginSuccess,
    saveCognitoUserInfo,
    saveUserDetails,
    updateLoginStatus,
    updateUserLanguage,
    setUserId,
    setUserName,
    setUserImageLink,
} = userSlice.actions;

export const userReducer = userSlice.reducer;
